import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import "@fontsource/roboto";
import 'semantic-ui-react'
require('dotenv').config();

ReactDOM.render(<App />, document.getElementById('root'));
